import * as React from 'react';
import styled from 'styled-components/macro';

import { colors, distances } from '../../styles/constants';
import { useEnvFrame } from '../../auth/accessToken/EnvFrame';

const Container = (
    {
        children,
    }: {
        children: React.ReactNode;
    }
) => {
    const hasEnvFrame = !!useEnvFrame();

    return (
        <ContainerWrapper>
            <ContainerInner hasEnvFrame={hasEnvFrame}>{children}</ContainerInner>
        </ContainerWrapper>
    );
};

const ContainerWrapper = styled.section`
    min-width: 248px;
    position: sticky;
    height: calc(100vh - 52px);
    top: 0;
    overflow: hidden;
    @media (max-width: 768px) {
        height: 44px;
        width: 100%;
        min-width: 100%;
        overflow-x: overlay;
        z-index: 2;
    }
`;

interface ContainerInnerProps {
    hasEnvFrame: boolean;
}

const ContainerInner = styled.div<ContainerInnerProps>`
    margin-top: ${(props) => (props.hasEnvFrame ? distances.tiny : '48px;')};
    background: ${colors.background};
    border-radius: 4px;
    margin-left: ${(props) => (props.hasEnvFrame ? '16px' : '20px')};
    margin-right: ${(props) => (props.hasEnvFrame ? '0' : '4px')};
    padding-top: 8px;
    padding-bottom: 8px;
    box-shadow: 0px 1px 2px rgba(0, 0, 0, 0.2);

    @media (max-width: 768px) {
        margin: 0;
        width: max-content;
        height: 40px;
        display: flex;
        padding: 0;
        position: relative;
        border-radius: 0px;
    }
`;

export default Container;
